import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SidebarTooltipProps {
  /** Tooltip metni */
  label: React.ReactNode;
  /** Tooltip'in aktif olup olmayacağı (örn: sadece sidebar daraltılmışken göster) */
  disabled?: boolean;
  children: React.ReactElement;
}

/**
 * Sidebar daraltılıp sadece ikonlar görünür olduğunda, hover'da isim/etiket
 * gösteren küçük bir yardımcı. `disabled` true ise (örn. sidebar açıksa)
 * hiçbir ekstra DOM/overhead eklemeden children'ı olduğu gibi render eder.
 */
export const SidebarTooltip: React.FC<SidebarTooltipProps> = ({
  label,
  disabled,
  children,
}) => {
  if (disabled) return children;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side="right"
          sideOffset={10}
          className="z-[1200] text-xs font-medium"
        >
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
